import React from 'react';
import { Chip } from '../../../../../components/Chip';
import { IconSpan } from '../../../../../components/IconSpan';
import { shortFormatDate } from '../../../../../utils/timeFormat';
import { Scorecard } from '../../../../../entities/applicant_tracking/Scorecard';
import { Interview } from '../../../../../entities/Interview';

interface PropTypes {
  scorecard: Scorecard;
  interview?: Interview;
}

export function ScorecardHeader(props: PropTypes) {
  return (
    <div className='d-flex flex-nowrap justify-content-between'>
      <Chip className='text-primary fw-semibold bg-light-warning'>
        {props.interview?.stage || props.scorecard.jobStage}
      </Chip>
      <Chip className='text-primary fw-semibold bg-light-info'>
        <IconSpan
          spanText={shortFormatDate(
            props.interview?.scheduled_date || new Date(),
          )}
          icon={{ name: 'bi-calendar' }}
        ></IconSpan>
      </Chip>
    </div>
  );
}
